// import React from "react";
// import { NavLink } from "react-router-dom";
// import MenuItemDropdown from "components/Dashboard/Sidebar/MenuItemDropdown.jsx";
// import Logout from "components/Auth/Logout.jsx";

// export default function LeftMenuItem(props) {
//   const { item, type, url, icon, label, premiumIcon, bottomMenu } = props;

//   return (
//     <li className={`menuItem menuItem${item} ${type === 2 ? "dropdown" : ""} ${bottomMenu ? "bottom-menu" : ""}`}>
//       {(() => {
//         switch (type) {
//           case 1:
//             return (
//               <NavLink to={`/admin/${url}`} activeClassName="menuCurrent">
//                 {icon && <img src={icon} alt={`${label} icon`} />}
//                 <span className={`menuText ${premiumIcon ? "crownIcon" : ""}`}>{label}</span>
//               </NavLink>
//             );
//           case 2:
//             return (
//               <>
//               {/* {icon && <img src={icon} alt={`${label} icon`} />} */}
//               <MenuItemDropdown {...props} />
//               </>
//             );
//           case 3:
//             return (
//           <>
//               {/* {icon && <img src={icon} alt={`${label} icon`} />}  */}
//               <Logout icon={icon} premiumIcon={premiumIcon} label={label} />             
//           </>
// 			)
//           default:
//             return null;
//         }
//       })()}
//     </li>
//   );
// }



import React from "react";
import { NavLink } from "react-router-dom";
import MenuItemDropdown from "components/Dashboard/Sidebar/MenuItemDropdown.jsx";
import Logout from "components/Auth/Logout.jsx";
import { useLocation } from 'react-router-dom';
import TooltipPortal from "views/TooltipPortal";
import { isWhiteLabel } from "utils/whiteLabel";

export default function LeftMenuItem(props) {
  const { item, type, url, icon, label, premiumIcon, bottomMenu, activeUrls, subscriptionType , onRefreshSubscription} = props;
  const location = useLocation();

  const getTourId = () => {
  switch (label) {
    case "Dashboard": return "tour-dashboard";
    case "Practice Material": return "tour-practice";
    case "Monthly Prediction": return "tour-monthly-prediction";
    case "Templates": return "tour-templates";
    case "Prediction Files": return "tour-prediction-files";
    case "Sectional Mock Tests": return "tour-extensive-mocks";
    case "Mock Tests": return "tour-mocks";
    case "Secret Strategy Videos": return "tour-videos";
    case "Daily Feedback": return "tour-daily-feedback";
    case "Live Session": return "tour-live-session";
    case "Notifications": return "tour-notifications";
    case "Need Help": return "tour-help";
    case "Subscriptions": return "tour-subscriptions";
    case "My Profile": return "tour-profile";
    case "Log Out": return "tour-logout";
    default: return undefined;
  }
};

const isPathActive = (pathname, activeUrls = []) => {
  const cleanPath = pathname.replace(/^\/|\/$/g, "");

  return activeUrls.some((url) => {
    const cleanUrl = url.replace(/^\/|\/$/g, "");

    return (
      cleanPath === cleanUrl ||
      cleanPath.startsWith(cleanUrl + "/")
    );
  });
};

// const activePath = () => {
//   return isPathActive(location.pathname.replace("/admin/", ""), activeUrls);
// };

const activePath = () => {
  const pathname = location.pathname.replace("/admin/", "");
  const searchParams = new URLSearchParams(location.search);
  const mockSource = searchParams.get('mock');
  
  // Special handling for progress page with mock parameter
  if (pathname.startsWith('progress/') && mockSource !== null) {
    if (label === 'Full Mock Tests' && mockSource === '1') return true;
    if (label === 'Sectional Mock Tests' && mockSource === '2') return true;
    if (label === 'Dashboard' && mockSource === '0') return true;
    return false;
  }
  
  return isPathActive(pathname, activeUrls);
};


  const tourId = getTourId();
  return (
    <li  id={tourId} className={`menuItem menuItem${item} ${type === 2 ? "dropdown" : ""} ${bottomMenu ? "bottom-menu" : ""} plan-${subscriptionType} ${!isWhiteLabel() ? "non-wl" : ""}`}>
      {(() => {
        switch (type) {
          case 1:
            return (
              // <NavLink to={`/admin/${url}`} className={() => activePath() ? "menuCurrent" : ""}>
              //   {icon && <img src={icon} alt={`${label} icon`} />}
              //   <span className={`menuText ${premiumIcon ? "crownIcon" : ""}`}>{label}</span>
              // </NavLink>
              <TooltipPortal label={label}>
                <NavLink
                  to={`/admin/${url}`}
                  className={activePath() ? "menuCurrent" : ""}
                   onClick={onRefreshSubscription}
                >
                   {/* {icon && <img src={icon} alt={`${label} icon`} />} */}
                  {/* <span className={`menuText ${premiumIcon ? "crownIcon" : ""}`}> */}
                  {icon && <img src={icon} alt={`${label} icon`} className={!isWhiteLabel() && !activePath() ? "non-wl-inactive" : ""} style={{filter: activePath() ? (isWhiteLabel() ? "brightness(2)" : "") : "brightness(1)"}}/>}
                  <span className={`menuText ${premiumIcon ? "crownIcon" : ""} ${!isWhiteLabel() && !activePath() ? "non-wl-inactive" : ""}`} style={{color: activePath() ? (isWhiteLabel() ? "#ffff" : "") : "#acacad"}}>
                  {label}
                  </span>
                </NavLink>
              </TooltipPortal>
            );
          case 2:
            return (
              <>
              {/* {icon && <img src={icon} alt={`${label} icon`} />} */}
              <TooltipPortal label={label}>
                <MenuItemDropdown {...props} />
              </TooltipPortal>
              </>
            );
          case 3:
            return (
          <>
              {/* {icon && <img src={icon} alt={`${label} icon`} />}  */}
              <TooltipPortal label={label}>
                <Logout icon={icon} premiumIcon={premiumIcon} label={label} />             
              </TooltipPortal>
          </>
			)
          default:
            return null;
        }
      })()}
    </li>
  );
}
